module.exports = __webpack_public_path__ + "img/camera-01.9c148cb8.svg";